import {SetInvoicePossibilityToOfferFromDialogExecutionStep} from './set-invoice-possibility-to-offer-from-dialog-execution-step';

export class SetInvoicePossibilityToOrderFromDialogExecutionStep extends SetInvoicePossibilityToOfferFromDialogExecutionStep {

}
